module.exports = __webpack_public_path__ + "static/img/t5.cb85eee4.png";